import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api.me().then(setUser).catch(() => api.refresh().then(setUser).catch(() => setUser(false)));
  }, []);

  const verify = useCallback(async (email, code) => {
    const u = await api.verifyCode(email, code);
    setUser(u);
    return u;
  }, []);
  const logout = useCallback(async () => {
    await api.logout().catch(() => {});
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, verify, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
